<template>
    <div id="investment-objectives" class="investment-objectives-wrapper pt-8 scroll-mt-56">
        <HeadingBarComponent :step="4" />
        <div class="md:flex">
            <!-- Left Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Types of Products you wish to transact</h3>
                <InputComponent label="Spot &amp; foreign exchange" :value="submission.investment_objectives.foreign_exchange ? 'Yes' : 'No'" />
                <InputComponent label="Shares, bonds &amp; funds" :value="submission.investment_objectives.shares_bonds_funds ? 'Yes' : 'No'" />
                <InputComponent label="Stock &amp; Index Options" :value="submission.investment_objectives.stock_index_options ? 'Yes' : 'No'" />
                <InputComponent label="Financial &amp; Commodity F &amp; O" :value="submission.investment_objectives.financial_commodity ? 'Yes' : 'No'" />
            </div>
        </div>
        <div class="px-8">
            <HrComponent />
            <InputComponent label="If the foregoing does not accurately represent your investment objectives, please specify below what your investment objectives are and what your investment horizon is:" :value="submission.investment_objectives.investment_objectives_details ? submission.investment_objectives.investment_objectives_details : 'N/A'" />
            <HrComponent />
            <h3 class="mb-4">Acceptance Criteria</h3>
            <CheckboxComponent label="Please confirm that your transactions and positions will be proprietary in nature." :value="!!submission.investment_objectives.confirm_proprietary_transactions" />
            <HrComponent class="mt-4" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from '@adminComponents/misc/HrComponent';
import InputComponent from '@adminComponents/inputs/InputComponent';
import CheckboxComponent from '@adminComponents/inputs/CheckboxComponent';

export default {
    name: "InvestmentObjectivesComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
        CheckboxComponent
    },
    computed: {
        ...mapGetters(["submission"])
    },
    data: function () {
        return {
            isLoading: false,
            quickView: true
        };
    },
    methods: {
        // ...mapActions(["doLogout"]),
    },
};
</script>
